module.exports = __webpack_public_path__ + "media/images/logo@2x-2376f29b2958e1f4055d9e1569ce71c0.png";